import { Graphics } from 'pixi.js';
import { CutAway } from '../core';

class BlackFrameCutAway extends CutAway {
  public blackFrame: Graphics;
  public duration: number;

  constructor() {
    super();
    this.duration = 20;
    this.blackFrame = new Graphics();
    this.blackFrame.beginFill(0x000000);
    this.blackFrame.drawRect(0, 0, this.sceneWidth, this.sceneHeight);
    this.blackFrame.endFill();
    this.addChild(this.blackFrame);
    this.text.visible = false;
  }

  public update(elapsed: number): void {
    super.update(elapsed);
    if (this.value < 1) {
      this.blackFrame.alpha = this.value;
    } else if (this.value > 1) {
      this.blackFrame.alpha = this.value - 1;
    }
  }

  public setSize(width: number, height: number): void {
    super.setSize(width, height);

    this.blackFrame.clear();
    this.blackFrame.beginFill(0x000000);
    this.blackFrame.drawRect(0, 0, this.sceneWidth, this.sceneHeight);
    this.blackFrame.endFill();
  }
}

export default BlackFrameCutAway;
